var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "user"
  }, [_c('div', {
    staticClass: "animated fadeIn"
  }, [_c('div', {
    staticClass: "col-md-12 mb-2"
  }, [_c('b-card', [_c('div', {
    staticClass: "card-body1"
  }, [_c('form', {
    staticClass: "form-horizontal",
    attrs: {
      "action": "",
      "method": "post"
    }
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v("User Name")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-user'></i>"
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "text",
      "placeholder": " Enter User Name"
    },
    model: {
      value: (_vm.username),
      callback: function($$v) {
        _vm.username = $$v
      },
      expression: "username"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v("User ID")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-user'></i>"
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "number",
      "placeholder": " Enter User ID"
    },
    model: {
      value: (_vm.userid),
      callback: function($$v) {
        _vm.userid = $$v
      },
      expression: "userid"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v("Old User ID")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-user'></i>"
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "number",
      "placeholder": "Enter Old User ID"
    },
    model: {
      value: (_vm.olduserid),
      callback: function($$v) {
        _vm.olduserid = $$v
      },
      expression: "olduserid"
    }
  })], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "serachbtn"
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.searchUserData
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  }), _vm._v(" Search")]), _vm._v("  "), _c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "reset"
    },
    on: {
      "click": _vm.resetForm
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh"
  }), _vm._v(" Reset")])])])])])], 1), _vm._v(" "), _c('vue-element-loading', {
    attrs: {
      "spinner": "spinner",
      "color": "#4b8cbb",
      "active": _vm.isLoading
    },
    on: {
      "update:active": function($event) {
        _vm.isLoading = $event
      }
    }
  }), _vm._v(" "), (_vm.resultCount) ? _c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "card-headerfrm",
    staticStyle: {
      "margin-bottom": "15px"
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-9"
  }, [_c('table', {
    staticClass: "table-bordered table-hover tbl datatables",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('tbody', [_vm._m(1), _vm._v(" "), _c('tr', [_c('th', {
    staticClass: "text-center "
  }, [_vm._v("User ID")]), _vm._v(" "), _c('td', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(_vm.userdata.liveusermaster.liveuserid))]), _vm._v(" "), _c('td', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(_vm.userdata.userid))])]), _vm._v(" "), _c('tr', [_c('th', {
    staticClass: "text-center "
  }, [_vm._v("Old User ID")]), _vm._v(" "), _c('td', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(_vm.userdata.liveusermaster.liveolduserid))]), _vm._v(" "), _c('td', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(_vm.userdata.OldDeliveryUserOrUserId))])]), _vm._v(" "), _c('tr', [_c('th', {
    staticClass: "text-center "
  }, [_vm._v("Name")]), _vm._v(" "), _c('td', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(_vm.userdata.liveusermaster.livefname) + "\n                    " + _vm._s(_vm.userdata.liveusermaster.livelname) + "\n                  ")]), _vm._v(" "), _c('td', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(_vm.userdata.FirstName) + " " + _vm._s(_vm.userdata.LastName))])]), _vm._v(" "), _c('tr', [_c('th', {
    staticClass: "text-center"
  }, [_vm._v("User Name")]), _vm._v(" "), _c('td', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(_vm.userdata.liveusermaster.liveusername))]), _vm._v(" "), _c('td', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(_vm.userdata.username))])]), _vm._v(" "), _c('tr', [_c('th', {
    staticClass: "text-center"
  }, [_vm._v("Email ID")]), _vm._v(" "), _c('td', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(_vm.userdata.liveusermaster.liveemail))]), _vm._v(" "), _c('td', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(_vm.userdata.email))])]), _vm._v(" "), _c('tr', [_c('th', {
    staticClass: "text-center"
  }, [_vm._v("Mobile Number")]), _vm._v(" "), _c('td', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(_vm.userdata.liveusermaster.livemobile))]), _vm._v(" "), _c('td', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(_vm.userdata.MobileNumber))])]), _vm._v(" "), _c('tr', [_c('th', {
    staticClass: "text-center"
  }, [_vm._v("Password")]), _vm._v(" "), _c('td', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(_vm.userdata.liveusermaster.livepassword))]), _vm._v(" "), _c('td', {
    staticClass: "text-center "
  }, [_vm._v(_vm._s(_vm.userdata.password))])]), _vm._v(" "), _c('tr', [_c('th', {
    staticClass: "text-center"
  }, [_vm._v("Out Sourcing ID")]), _vm._v(" "), _c('td', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(_vm.userdata.liveusermaster.liveoutsourceid))]), _vm._v(" "), _c('td', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(_vm.userdata.OutSourcingID) + " ")])]), _vm._v(" "), _c('tr', [_c('th', {
    staticClass: "text-center"
  }, [_vm._v("Modified Date")]), _vm._v(" "), _c('td', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(_vm._f("gmttoist")(_vm.userdata.liveusermaster.livemodifieddate)))]), _vm._v(" "), _c('td', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(_vm._f("gmttoist")(_vm.userdata.modifieddatetime)))])]), _vm._v(" "), _c('tr', [_c('th', {
    staticClass: "text-center "
  }, [_vm._v("Modified By")]), _vm._v(" "), _c('td', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(_vm.userdata.liveusermaster.livemodifiedby))]), _vm._v(" "), _c('td', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(_vm.userdata.modifiedby))])]), _vm._v(" "), _c('tr', [_c('th', {
    staticClass: "text-center "
  }, [_vm._v("Status")]), _vm._v(" "), _c('td', {
    staticClass: "text-center"
  }, [(_vm.userdata.liveusermaster.livestatus == true) ? _c('span', {
    staticClass: "badge badge-success"
  }, [_vm._v("Active")]) : _vm._e(), _vm._v(" "), (_vm.userdata.liveusermaster.livestatus == false) ? _c('span', {
    staticClass: "badge badge-danger"
  }, [_vm._v("Inactive")]) : _vm._e()]), _vm._v(" "), _c('td', {
    staticClass: "text-center"
  }, [(_vm.userdata.status == true) ? _c('span', {
    staticClass: "badge badge-success"
  }, [_vm._v("Active")]) : _vm._e(), _vm._v(" "), (_vm.userdata.status == false) ? _c('span', {
    staticClass: "badge badge-danger"
  }, [_vm._v("Inactive")]) : _vm._e()])]), _vm._v(" "), _c('tr', [_c('th', {
    staticClass: "text-center "
  }, [_vm._v("Hub ID")]), _vm._v(" "), _c('td', {
    staticClass: "text-center "
  }, [_vm._v(_vm._s((_vm.LiveHubs.length) ? _vm.LiveHubs : ''))]), _vm._v(" "), _c('td', {
    staticClass: "text-center "
  }, [_vm._v(_vm._s((_vm.UsermasterHubs.length) ? _vm.UsermasterHubs : ''))])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('b-card', [_c('h4', {
    staticClass: "header"
  }, [_c('i', {
    staticClass: "fa fa-bars barcolor",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Actions")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('i', {
    staticClass: "fa fa-male text-successedit fa-lg mt-2 ml-3",
    staticStyle: {
      "cursor": "pointer"
    },
    attrs: {
      "title": "Check INHAgent"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.getOutSourcingEntityType(_vm.userdata.OutSourcingID)
      }
    }
  }), _c('vue-element-loading', {
    attrs: {
      "spinner": "spinner",
      "color": "#4b8cbb",
      "active": _vm.isINHLoader
    },
    on: {
      "update:active": function($event) {
        _vm.isINHLoader = $event
      }
    }
  }), _vm._v("   Check INH Agent\n                ")], 1), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('i', {
    staticClass: "fa fa-key text-successedit fa-lg mt-2 ml-3",
    staticStyle: {
      "cursor": "pointer"
    },
    attrs: {
      "title": "Update Password"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.updatePasswordString(_vm.userdata.userid, _vm.userdata.liveusermaster.livepassword)
      }
    }
  }), _c('vue-element-loading', {
    attrs: {
      "spinner": "spinner",
      "color": "#4b8cbb",
      "active": _vm.isPasswordLoader
    },
    on: {
      "update:active": function($event) {
        _vm.isPasswordLoader = $event
      }
    }
  }), _vm._v("  Update Password\n                ")], 1), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('i', {
    staticClass: "fa fa-sign-in text-successedit fa-lg mt-2 ml-3",
    staticStyle: {
      "cursor": "pointer"
    },
    attrs: {
      "title": "Generate Login Token"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.getProjectsByType(_vm.userdata.utype)
      }
    }
  }), _c('vue-element-loading', {
    attrs: {
      "spinner": "spinner",
      "color": "#4b8cbb",
      "active": _vm.isTokenLoader
    },
    on: {
      "update:active": function($event) {
        _vm.isTokenLoader = $event
      }
    }
  }), _vm._v("  Check Track Login\n                ")], 1), _c('br'), _vm._v(" "), (_vm.userdata.IsMobileLoggedIn === true) ? _c('div', {
    staticClass: "col-md-12"
  }, [(_vm.userdata.IsMobileLoggedIn === true) ? _c('i', {
    staticClass: "fa  fa-mobile fa-lg mt-2 ml-3",
    staticStyle: {
      "cursor": "pointer",
      "color": "red"
    },
    attrs: {
      "title": "Mobile Forced Logout"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.getforcedLogoutRowData(_vm.userdata.userid, 'mobile')
      }
    }
  }) : _vm._e(), _vm._v("  Mobile Forced Logout\n                ")]) : _vm._e()])])], 1)])])]) : _vm._e(), _vm._v(" "), _c('b-modal', {
    attrs: {
      "id": "#forcedLogoutmodal",
      "title": "Confirmation"
    },
    on: {
      "click": function($event) {
        _vm.addforcedLogoutmodalShow = false
      }
    },
    model: {
      value: (_vm.forcedLogoutmodalShow),
      callback: function($$v) {
        _vm.forcedLogoutmodalShow = $$v
      },
      expression: "forcedLogoutmodalShow"
    }
  }, [_c('div', {
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-headerfrm"
  }, [_c('h5', {
    staticClass: "modal-title"
  }, [_vm._v("Confirmation")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    },
    on: {
      "click": _vm.closeforcedLogoutModal
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-bodyfrm"
  }, [_c('p', [_vm._v(" Are you sure you want force log out this user?")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footerfrm"
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button"
    },
    on: {
      "click": [function($event) {
        _vm.forcedLoggoutUser()
      }, function($event) {
        _vm.modalShow = false
      }]
    }
  }, [_vm._v("Yes")]), _vm._v("  "), _c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    },
    on: {
      "click": _vm.closeforcedLogoutModal
    }
  }, [_vm._v("No")])])])])]), _vm._v(" "), _c('b-modal', {
    attrs: {
      "size": "vlg"
    },
    model: {
      value: (_vm.projectModal),
      callback: function($$v) {
        _vm.projectModal = $$v
      },
      expression: "projectModal"
    }
  }, [_c('b-card', [_c('div', {
    slot: "header"
  }, [_c('span', {
    staticClass: "mdltitle"
  }, [_vm._v("User Type-wise Projects")]), _vm._v(" "), _c('i', {
    staticClass: "fa fa-window-close-o close",
    staticStyle: {
      "cursor": "pointer"
    },
    attrs: {
      "aria-hidden": "true"
    },
    on: {
      "click": _vm.closeProjectModal
    }
  })]), _vm._v(" "), _c('vue-element-loading', {
    attrs: {
      "spinner": "spinner",
      "color": "#4b8cbb",
      "active": _vm.projectLoader
    },
    on: {
      "update:active": function($event) {
        _vm.projectLoader = $event
      }
    }
  }), _vm._v(" "), _c('vue-element-loading', {
    attrs: {
      "spinner": "spinner",
      "color": "#4b8cbb",
      "active": _vm.isLoginChecked
    },
    on: {
      "update:active": function($event) {
        _vm.isLoginChecked = $event
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, _vm._l((_vm.projectList), function(project_obj, index) {
    return _c('div', {
      staticClass: "col-xs-2"
    }, [_c('a', {
      on: {
        "click": function($event) {
          _vm.redirectToLogin(project_obj.project.appkey)
        }
      }
    }, [_c('div', {
      staticClass: "card border-info",
      staticStyle: {
        "width": "18rem",
        "margin-right": "10px"
      }
    }, [_c('div', {
      staticClass: "card-body"
    }, [_c('h6', {
      staticClass: "card-title"
    }, [_vm._v(_vm._s(project_obj.project.projectname))]), _vm._v(" "), _c('i', {
      staticClass: "fa fa-external-link btn btn-primary",
      attrs: {
        "aria-hidden": "true"
      }
    }, [_vm._v(" Generate Token")])])])])])
  }))], 1)], 1)], 1)])
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h4', {
    staticClass: "header"
  }, [_c('i', {
    staticClass: "fa fa-bars barcolor",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" User Details")])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('th', {
    staticClass: "text-center"
  }), _vm._v(" "), _c('td', {
    staticClass: "text-center",
    staticStyle: {
      "font-weight": "bold"
    }
  }, [_vm._v("Live User Master")]), _vm._v(" "), _c('td', {
    staticClass: "text-center",
    staticStyle: {
      "font-weight": "bold"
    }
  }, [_vm._v("User Master")])])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-40ff5a0a","hasScoped":true}!./src/views/components/userdetailtableview/userdetailtableview.component.html
// module id = 855
// module chunks = 1